const getCookie = (name) => {
    let nameEQ = name + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

const setCookie = (name, value, days) => {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    let expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  };

document.addEventListener("DOMContentLoaded", () => {
  const parseUTMParameters = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return {
        utmSource: urlParams.get('utm_source'),
        utmMedium: urlParams.get('utm_medium'),
        utmCampaign: urlParams.get('utm_campaign'),
        adGroup: urlParams.get('adgroup'),
        device: urlParams.get('device'),
        gadSource: urlParams.get('gad_source'),
        gclid: urlParams.get('gclid')
    };
  };
  
  const grabUTMCodes = () => {
    const utmParams = parseUTMParameters();

    if (utmParams && utmParams.utmSource != null) {
      setCookie("UTMVAL", JSON.stringify(utmParams), 30);
    }
  };

  const parseSSOParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const ssoVal = urlParams.get('augos-sso');
    if (ssoVal) {
      setCookie("agso_", true, 1);
    }
  };

  grabUTMCodes();
  parseSSOParams();
});